module.exports = __webpack_public_path__ + "static/media/IMG_20170810_220930_DRO.34dba784.jpg";